import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import cs from 'vuetify/src/locale/cs';
import en from 'vuetify/src/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  lang: {
    locales: { cs, en },
    current: 'cs'
  }
});
